export const darkTheme = {
  primary: {
    600: '#1a202c',
    900: '#171923',
  },
  grey: { 300: '#fff' },
  white: '#fff',
  teal: {
    100: '#5DDADB',
  },
  green: {
    200: '#389493',
    300: '#2C7A7B',
  },
  scrollbar: {
    border: '#ffffff',
    thumb: {
      bg: '#e1e1e1',
    },
  },
  loader: {
    teal: '#5DDADB',
    purple: '#3437A2',
    pink: '#F78EB6',
    bg: '#171923db',
  },
  gradient: {
    blue: {
      300: '#002eb3',
      600: '#002360',
      900: '#051937',
    },
  },

  text: {
    grey: {
      300: '#a0aec0',
      500: '#718096',
    },
  },

  timeline: {
    divider: {
      bg: '#718096',
    },
  },
  grid: {
    item: '#7180961a',
    divider: '#7180961a',
    highlight: '#38B2AC',
  },
};

export const lightTheme = {
  primary: {
    600: '#f7fafc',
    900: '#edf2f7',
  },
  grey: { 300: '#4a5568' },
  white: '#000',
  teal: {
    100: '#319795',
  },
  green: {
    200: '#2C7A7B',
    300: '#285E61',
  },
  scrollbar: {
    border: '#e2e8f0',
    thumb: {
      bg: '#718096',
    },
  },
  loader: {
    teal: '#319795',
    purple: '#5A67D8',
    pink: '#D53F8C',
    bg: '#f7fafc',
  },
  gradient: {
    blue: {
      300: '#fff',
      600: '#fff',
      900: '#fff',
    },
  },
  text: {
    grey: {
      300: '#a0aec0',
      500: '#718096',
    },
  },

  timeline: {
    divider: {
      bg: '#718096',
    },
  },
  grid: {
    item: '#7180961a',
    divider: '#7180961a',
    highlight: '#38B2AC',
  },
};
